/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Player_Reached_Max_RoundsInputs */



/**
* | output |
* | --- |
* | "Player has reached their maximum number of rounds" |
*
* @param {Err_Tournament_Player_Reached_Max_RoundsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_player_reached_max_rounds = /** @type {((inputs?: Err_Tournament_Player_Reached_Max_RoundsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Player_Reached_Max_RoundsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le joueur a atteint son nombre maximum de rondes")
	if (locale === "es") return /** @type {LocalizedString} */ ("El jugador ha alcanzado su número máximo de rondas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O jogador atingiu o número máximo de rodadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il giocatore ha raggiunto il numero massimo di round")
	return /** @type {LocalizedString} */ ("Player has reached their maximum number of rounds")
});